// extracted by mini-css-extract-plugin
export default {"bonuses":"style_bonuses__myRW7"};